<template>
  <div class="top-div">
    <h5 class="title">{{$t('user.createwallet.imtoken.title')}}</h5>
    <p class="tip">
      {{$t('user.createwallet.imtoken.tip-1')}}
    </p>
    <p class="tip">
      {{$t('user.createwallet.imtoken.tip-2')}}
    </p>
    <p class="tip">
      {{$t('user.createwallet.imtoken.tip-3')}}
    </p>
    <p class="tip">
      {{$t('user.createwallet.imtoken.tip-4')}}
    </p>
    <p class="tip">
      {{$t('user.createwallet.imtoken.tip-5')}}
    </p>
    <div class="btn-group">
      <button class="white-btn" @click="toPath('home')">{{$t('user.createwallet.imtoken.nobackup')}}</button>
      <button class="blue-btn" @click="backup()">{{$t('user.createwallet.imtoken.backup')}}</button>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    backup() {
      this.$emit("next", "IMtokenTip");
    },
    toPath(name) {
      this.$router.push({name})
    },
  },
};
</script>
<style lang="scss" scoped>
.top-div{
  .title{
    font-size: 1.6rem;
    font-weight: bold;
    color: #333333;
    padding-bottom: 0.8rem;
    border-bottom: 0.05rem solid #dedede;
    margin-bottom: 1.5rem;
  }
  .tip{
    font-size: 1.4rem;
    font-weight: 400;
    color: rgba(51,51,51,0.7);
    margin-bottom: 1.4rem;
  }
  .btn-group{
    .blue-btn{
      outline: none;
      width: 100%;
      height: 4.9rem;
      background: #DC472A;
      border-radius: 0.4rem;
      border: none;
      color: #ffffff;
    }
    .white-btn{
      outline: none;
      width: 100%;
      height: 4.9rem;
      background: #ffffff;
      border-radius: 0.4rem;
      color: #838383;
      border: 0.1rem solid #E5E5E5;
      margin: 3.4rem 0 1rem 0;
    }
  }
}
@media screen and (max-width: 768px){
.top-div{
  .btn-group{
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    bottom: 4.1rem;
    min-width: 96%;
  }
}
}
</style>
